module.exports = __webpack_public_path__ + "media/img/pages/profile/lidl ger 1-fafaea7fcd9143dda010ba25f815b68b.jpg";